module.exports = __webpack_public_path__ + "img/J12327.eb2fd2ab.png";